import { differenceInDays } from 'date-fns';
import { RECENT_DAYS_COUNT } from '../constants';

export const isRecent = (lastUpdatedDate: Date): boolean =>
  differenceInDays(new Date(), lastUpdatedDate) <= RECENT_DAYS_COUNT;
